module.exports = __webpack_public_path__ + "static/img/icon_rtk.3fb5f3b8.png";